import React, { useState, } from 'react'
import { useSelector } from 'react-redux';
import './FooterButtons.css'

function FooterButtons(props) {
  const { leaveCall } = props
  let { isCelebrity, roomLink } = useSelector(state => state.participant);

  const [copied, setCopiedState] = useState(false)

  const copyLink = () => {

    const el = document.createElement('textarea');
    el.value = roomLink;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    setCopiedState(true)

    setTimeout(() => {
      setCopiedState(false)
    }, 1400)
  };

  return (
    <div className={`sfb-buttons-container ${isCelebrity ? 'celebrity' : ''}`}>
      <div className='sfb-footer-buttons'>
        <button
          className='sfb-button'
          onClick={leaveCall}
        >
          <div>Leave session</div>

          <div className='s-sd-arrow-right' />
        </button>
      </div>
      {!isCelebrity && (
        <div className='sfb-footer-buttons'>
          <button
            className={`sfb-button ${copied ? 'active' : ''}`}
            onClick={copyLink}
          >
            <div>{copied ? (
              'Copied'
            ) : (
                'Copy link'
              )}</div>
          </button>
        </div>
      )}
    </div>
  )
}

export default FooterButtons
